import ColorHash from 'color-hash-ts';

import { useTranslation } from 'react-i18next';

export type SymptomsChartProps = {
  dayValues: string[][];
  translationKeyPrefix?: string;
  colorMap?: Record<string, string>;
  // overrides the default colour dot with a custom icon for specific values (e.g. an X instead of a
  // colour, for a "none" option that a colour swatch can't represent on its own)
  iconMap?: Record<string, React.ReactNode>;
};

const SymptomsChart: React.FC<SymptomsChartProps> = ({
  dayValues,
  translationKeyPrefix = 'symptomTracking.survey.symptoms',
  colorMap,
  iconMap,
}) => {
  const { t } = useTranslation();
  const colorHash = new ColorHash();

  const allSymptoms = new Set<string>();
  dayValues.forEach(daySymptoms => {
    daySymptoms.forEach(symptom => allSymptoms.add(symptom));
  });

  return (
    <div>
      {Array.from(allSymptoms)
        .sort()
        .reverse()
        .map(symptom => (
          <span className="mr-3 inline-flex items-center text-subtle-foreground" key={symptom}>
            {iconMap?.[symptom] ?? (
              <div
                className="mr-1 inline-block size-2 rounded-full"
                style={{ backgroundColor: colorMap?.[symptom] ?? colorHash.hex(symptom) }}
              />
            )}
            {t(`${translationKeyPrefix}.${symptom}`)}
          </span>
        ))}
    </div>
  );
};
export default SymptomsChart;
